module.exports = __webpack_public_path__ + "static/img/67066G_2_3_R_20190904_fit.e9ca2dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066G_2_3_R_20190904_fit.png
// module id = 3xjq
// module chunks = 0